import api from "./axios";

// src/api/favourites.js
export const getFavourites = () =>
  api.get("/users/me/favourites").then((r) => r.data);
export const addFavourite = (carId) =>
  api.post("/users/me/favourites", { carId }).then((r) => r.data);
export const removeFavourite = (carId) =>
  api.delete(`/users/me/favourites/${carId}`).then((r) => r.data);
